import styled from '@emotion/styled';

export const SpinnerContainer = styled.span`
  margin-right: 10px;
`
